import styled, { css } from 'styled-components';

import { CloseButton } from 'components/Button';
import { Container } from 'components/Container';
import { colors } from 'theme';

export const StyledContainer = styled(Container)`
  position: absolute;
  transform: translate3d(0, 100%, 0);
  top: -10px;
  right: 10px;
  width: 300px;
  background-color: white;
  background-image: linear-gradient(
    to left,
    ${colors.skyBlue},
    ${colors.niceBlue}
  );
  background-size: 100% 7px;
  background-repeat: no-repeat;
  background-position: left top;
  box-shadow: 0 5px 12px 2px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  color: ${colors.battleshipGrey};
  font-size: 14px;
  text-align: left;
  z-index: 1;
  &::before {
    content: '';
    position: absolute;
    top: -10px;
    ${(props) =>
      props.$left
        ? css`
            left: 30px;
          `
        : css`
            right: 10px;
          `};
    z-index: 1;
    transform: translate(-16px, -4px);
    width: 0;
    height: 0;
    border: 8px solid transparent;
    border-bottom-color: ${(props) =>
      props.$left ? colors.niceBlue : colors.skyBlue};
    border-right-color: ${(props) =>
      props.$left ? colors.niceBlue : colors.skyBlue};
    transition: all 0.3s ease;
  }
`;

export const StyledCloseButton = styled(CloseButton)`
  position: absolute;
  color: ${colors.battleshipGrey};
  padding: 10px;
  right: 0;
  top: 0;

  &:hover {
    color: ${colors.waterBlue};
    &:disabled {
      &:hover {
        color: ${colors.battleshipGrey};
      }
    }
  }
`;
